export default __webpack_public_path__ + "static/media/pinkclouds.d9ababf0.png";